var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.classData)?_c('v-layout',[_c('v-flex',{attrs:{"md12":"","xs12":"","sm12":""}},[_c('marks-table',{attrs:{"classData":_vm.classData}})],1)],1):_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":"caƒrd"}})}
var staticRenderFns = []

export { render, staticRenderFns }